<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:button>
			<sf-button v-if="isButton_(scrId, 'CU')" size="lg" color="default" :line="false" className="sf-button--black-light" :onClick="Save">{{
				getMessage_('SWCC000103')
			}}</sf-button>
			<sf-button
				v-if="isButton_(scrId, 'CD')"
				size="lg"
				color="default"
				:line="false"
				className="sf-button--black-light"
				:onClick="Delete"
				>{{ getMessage_('SWCC000328') }}</sf-button
			>
		</template>
		<template v-slot:content>
			<center-content ref="content" :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
import CenterContent from './Content/Content.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		CenterContent
	},
	data() {
		return {
			screen: {},
			title: '다국어/메시지 관리',
			faivorite: true
			// locations: ['시스템관리', '다국어/메시지 관리']
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		PopupOpen(param) {
			this.$refs.content.PopupOpen(param);
		},
		Save() {
			this.$refs.content.$refs.table.saveClick();
		},
		Delete() {
			this.$refs.content.$refs.table.deleteClick();
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
